

















































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../general/OnscreenMenu.vue";
import CategoryTypeSelect from "../general/CategoryTypeSelect.vue";
import ClientsClientDetails from "./ClientsClientDetails.vue";

import SettingsJson from "../../shared/SettingsJson";
import ClientJson from "../../shared/ClientJson";
import CategoryTypeJson from "../../shared/CategoryTypeJson";
import { CategoryTypeType } from "../../shared/CategoryTypeType";
import { ClientStatus, ClientStatusNames } from "../../shared/ClientStatus";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "ClientsAll",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
    CategoryTypeSelect,
    ClientsClientDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    appFrameClickedButton: Object,
    allActiveModules: Array as PropType<ModulesJson[]>,
    userActiveModules: Array as PropType<ModulesJson[]>,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      CategoryTypeType: CategoryTypeType,
      GeneralInfos: GeneralInfos,
      checkModuleIsActivated: checkModuleIsActivated,
      showDetails: false,
      detailsMode: "read",
      useFilters: false as boolean,
      filterCategoryTypes: [] as CategoryTypeJson[],
      filterIncludeMailings: false as boolean,
      filterRestrictedTypesManagement: false as boolean,
      filterRestrictedTypesLogin: false as boolean,
      searchString: null as string | null,
      allClients: null as ClientJson[] | null,
      clientsMoreAvailable: null as boolean | null,
      selectedClientId: null as number | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: ClientJson | null, mode: string) {
      if (item != null) {
        this.selectedClientId = item.ID;
      } else {
        this.selectedClientId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllClients();
    },

    async loadAllClients(loadMore: null = null) {
      //show loading on search or remove search
      if (this.searchString !== null) {
        if (loadMore == null) {
          this.allClients = null;
        }
        if (this.searchString == "") {
          this.searchString = null;
        }
      }

      var typeIds = null;
      var onlyCreatedByManagement = false;
      var onlyWithLogin = false;
      var includeClientMailings = false;
      var skipAmount = null as number | null;

      //filters
      if (this.useFilters) {
        if (this.filterCategoryTypes.length > 0) typeIds = this.filterCategoryTypes.map((i: CategoryTypeJson) => i.ID!);
        onlyCreatedByManagement = this.filterRestrictedTypesManagement;
        onlyWithLogin = this.filterRestrictedTypesLogin;
        includeClientMailings = this.filterIncludeMailings;
      }

      //load more
      if (loadMore && this.allClients != null) {
        this.clientsMoreAvailable = null;
        skipAmount = this.allClients.length;
      } else {
        this.allClients = null;
      }

      if (this.restClient != null) {
        try {
          let clients = await this.restClient.getClients(
            typeIds,
            onlyCreatedByManagement,
            onlyWithLogin,
            includeClientMailings,
            this.searchString,
            skipAmount
          );

          if (loadMore && this.allClients != null) {
            this.allClients = this.allClients.concat(clients.clients);
          } else {
            this.allClients = clients.clients;
          }

          this.clientsMoreAvailable = clients.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    reloadData() {
      this.loadAllClients();
    },

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();

      this.loadAllClients();
    },

    removeUseFilters() {
      this.useFilters = false;

      this.filterCategoryTypes = [];
      this.filterIncludeMailings = false;
      this.filterRestrictedTypesManagement = false;
      this.filterRestrictedTypesLogin = false;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();

      this.loadAllClients();
    },

    resetSearchString() {
      this.searchString = "";

      this.loadAllClients();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    clientColumns: function (): TableViewColumnDefinitions<ClientJson>[] {
      let vue = this;

      return [
        {
          th: "Vorname",
          td: (i) => (i.contact?.firstName != "" ? i.contact?.firstName : "--"),
        },
        {
          th: "Nachname",
          td: (i) => (i.contact?.lastName != "" ? i.contact?.lastName : "--"),
        },
        {
          th: "E-Mail",
          td: (i) => (i.contact?.email != "" ? i.contact?.email : "--"),
        },
        {
          th: "Kategorien",
          td: "",
          categoryLabel: (i) => i.types ?? [],
        },
        {
          th: "Status",
          td: (i) => ClientStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<ClientJson>[];
    },
  },
});
